(function () {
  'use strict';

  if (window.AirXWishlist) return;

  var KEY = 'airx:curator:favorites';
  var MAX = 24;
  var EVENT = 'airx:wishlist:changed';

  function clean(value, max) {
    return String(value == null ? '' : value)
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }

  function read() {
    var raw;
    try { raw = window.localStorage.getItem(KEY); } catch (e) { return []; }
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (i) { return i && clean(i.h, 80) && clean(i.t, 120); })
        .map(function (i) {
          return {
            h: clean(i.h, 80),
            t: clean(i.t, 120),
            p: clean(i.p, 80),
            img: clean(i.img, 1000),
            min: Math.max(0, Number(i.min) || 0),
            o: clean(i.o, 30),
            c: clean(i.c, 60)
          };
        })
        .slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {  }
    document.dispatchEvent(new CustomEvent(EVENT, {
      detail: { count: list.length, handles: list.map(function (i) { return i.h; }) }
    }));
  }

  var api = {
    KEY: KEY,
    MAX: MAX,
    EVENT: EVENT,
    list: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) {
      var h = clean(handle, 80);
      return read().some(function (i) { return i.h === h; });
    },

    toggle: function (record) {
      if (!record || !clean(record.h, 80) || !clean(record.t, 120)) return null;
      var list = read();
      var h = clean(record.h, 80);
      var at = list.findIndex(function (i) { return i.h === h; });
      var saved;
      if (at > -1) { list.splice(at, 1); saved = false; }
      else {
        list.unshift({
          h: h,
          t: clean(record.t, 120),
          p: clean(record.p, 80),
          img: clean(record.img, 1000),
          min: Math.max(0, Number(record.min) || 0),
          o: clean(record.o, 30),
          c: clean(record.c, 60)
        });
        saved = true;
      }
      write(list);
      return saved;
    },
    remove: function (handle) {
      var h = clean(handle, 80);
      var list = read().filter(function (i) { return i.h !== h; });
      write(list);
    },
    on: function (fn) {
      document.addEventListener(EVENT, fn);
      return function () { document.removeEventListener(EVENT, fn); };
    }
  };

  window.AirXWishlist = api;

  function recordFrom(el) {
    return {
      h: el.getAttribute('data-handle'),
      t: el.getAttribute('data-title'),
      p: el.getAttribute('data-price'),
      img: el.getAttribute('data-img'),
      min: el.getAttribute('data-min'),
      o: el.getAttribute('data-orientation'),
      c: el.getAttribute('data-category')
    };
  }

  function paint(el) {
    var saved = api.has(el.getAttribute('data-handle'));
    el.classList.toggle('is-saved', saved);
    el.setAttribute('aria-pressed', String(saved));
    var label = el.getAttribute(saved ? 'data-label-saved' : 'data-label-save');
    if (label) {
      var text = el.querySelector('[data-wishlist-label]');
      if (text) text.textContent = label;
      el.setAttribute('aria-label', label);
    }
  }

  function paintAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(paint);
    var n = api.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });

    document.querySelectorAll('[data-wishlist-link]').forEach(function (el) {
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();

    if (btn.getAttribute('data-require-account') === 'true' && btn.getAttribute('data-logged-in') !== 'true') {
      var url = btn.getAttribute('data-login-url') || '/account/login';
      var back = window.location.pathname + window.location.search;
      window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + encodeURIComponent(back);
      return;
    }

    api.toggle(recordFrom(btn));
  });

  api.on(paintAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) paintAll();
  });
  document.addEventListener('shopify:section:load', paintAll);
})();
